/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// Regenerator runtime for async/await support
import 'regenerator-runtime/runtime'

// Array.at() polyfill for older browsers
if (!Array.prototype.at) {
  Array.prototype.at = function(index) {
    const len = this.length;
    const relativeIndex = index >= 0 ? index : len + index;
    return relativeIndex >= 0 && relativeIndex < len ? this[relativeIndex] : undefined;
  };
}

import Vue from 'vue'
import App from './App.vue'


// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// axios
import axios from "./axios.js"
// API Calls
import "./http/requests"

// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

import {VMoney} from 'v-money'
import VSelect from 'vue-select';
import VDatePicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css';
import {VTextField} from 'vuetify/lib';
import {debounce} from 'v-debounce'
import {VueMaskDirective} from 'v-mask'
// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
// Tour
import VueTour from 'vue-tour'
import UUID from 'vue-uuid';
import VueEsc from 'vue-esc';
// VeeValidate
import tr from 'vee-validate/dist/locale/tr';
import VeeValidate from 'vee-validate';
// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import _ from 'lodash'

import './registerServiceWorker'
import * as VueGoogleMaps from "vue2-google-maps";
import VueSimpleAlert from "vue-simple-alert";

Vue.use(Vuesax)


Vue.prototype.$http = axios


Vue.directive('money', VMoney);

Vue.directive('focus-datepicker', {
  inserted: function (el) {
    el.getElementsByClassName("vdp-datepicker__calendar")[0].style.display = "unset";
  }
});

Vue.directive('focus-input', {
  inserted: function (el) {
    el.querySelector("input").focus()
  }
});

Vue.directive('icon', {
  bind: function (el, binding) {
    el.insertAdjacentHTML('afterbegin', binding.value);
  }
});

Vue.directive('icon-class', {
  bind: function (el, binding) {
    el.querySelector("i").className += ' ' + binding.value
  }
});

Vue.directive('w-auto-full', {
  inserted: function (el, binding) {
    let preElementWidth = el.parentNode.firstChild.offsetWidth;
    el.style.width = 'calc(100% - ' + (preElementWidth + 1) + 'px)';
  }
});
VSelect.props.filterBy.default = function (option, label, search) {
  return (label || "").toLocaleLowerCase('tr-TR').indexOf((search || "").toLocaleLowerCase('tr-TR')) > -1
};
Vue.component("v-select", VSelect)
Vue.component("v-date-picker", VDatePicker);

Vue.component("flat-pickr", flatPickr);

Vue.component("v-text-field", VTextField);

Vue.directive('debounce', debounce);

Vue.directive('mask', VueMaskDirective);


Vue.use(VueClipboard);


Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

Vue.use(UUID);

Vue.use(VueEsc);


Vue.use(VeeValidate, {
  locale: 'tr',
  dictionary: {
    tr: tr
  }
});

Vue.use(VueHammer)
Vue.use(VueSimpleAlert);


// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
//import 'vue-select/dist/vue-select.css';
/*import vuetify from './plugins/vuetify';
Vue.use(vuetify)*/
Vue.prototype._ = _;

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDydu6rFh8JYCemG3Yn1Irv7zHGAtCKvg8",
    libraries: "places" // necessary for places input
  }
});

Vue.prototype.$years = function () {
  return [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]
};

Vue.prototype.$afkTimeOut = process.env.VUE_APP_AFK_TIMEOUT;

Vue.prototype.$getOrderStatusColor = function(status) {
  if (status == null) {
    return null;
  }
  switch (status) {
    case -1:
      //draft
      return "text-primary";
    case 0:
      //preparing
      return "text-info";
    case 1:
      //awating
      return "text-warning";
    case 2:
      //completed
      return "text-success";
    case 3:
      //missing complete
      return "text-purple";
    case 4:
      //sended
      return "text-dark-green";
    case 5:
      //missing send
      return "text-light-purple";
    case 6:
      // cancel
      return "text-danger";
  }
}

Vue.prototype.$getOrderStatus = function(status) {
  if (status == null) {
    return null;
  }
  switch (status) {
    case -1:
      return "Taslak Sipariş";
    case 0:
      return "Sipariş Hazırlanıyor";
    case 1:
      return "Sipariş Beklemede";
    case 2:
      return "Sipariş Tamamlandı";
    case 3:
      return "Eksik Ürünler Bekleniyor";
    case 4:
      return "Sipariş Gönderildi";
    case 5:
      return "Sipariş Eksik Gönderildi";
    case 6:
      return "Sipariş İptal Edildi";
  }
}

Vue.prototype.$addMonths = function (date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
};

Vue.prototype.$addDays = function (date,days){
  var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
Vue.prototype.$getMonth = function () {
  let now = toTurkishNow();
  return Vue.prototype.$months()[now.getMonth()];
}
Vue.prototype.$months = function () {
  return [{
    id: 1,
    name: 'Ocak'
  }, {
    id: 2,
    name: 'Şubat'
  }, {
    id: 3,
    name: 'Mart'
  }, {
    id: 4,
    name: 'Nisan'
  }, {
    id: 5,
    name: 'Mayıs'
  }, {
    id: 6,
    name: 'Haziran'
  }, {
    id: 7,
    name: 'Temmuz'
  }, {
    id: 8,
    name: 'Ağustos'
  }, {
    id: 9,
    name: 'Eylül'
  }, {
    id: 10,
    name: 'Ekim'
  }, {
    id: 11,
    name: 'Kasım'
  }, {
    id: 12,
    name: 'Aralık'
  }];
}

Vue.prototype.$days = function () {
  return [{
      id: 1,
      name: "Pazartesi"
    },
    {
      id: 2,
      name: "Salı"
    },
    {
      id: 3,
      name: "Çarşamba"
    },
    {
      id: 4,
      name: "Perşembe"
    },
    {
      id: 5,
      name: "Cuma"
    },
    {
      id: 6,
      name: "Cumartesi"
    },
    {
      id: 0,
      name: "Pazar"
    }
  ]
}

Vue.prototype.$now = function () {
  return toTurkishNow();
}

Vue.prototype.$preDate = function(){
  let now = toTurkishNow();
  return new Date(now.setDate(now.getDate() -1));
}

Vue.prototype.$now.date = function () {
  let now = toTurkishNow();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

Vue.prototype.$nullImage = require('@/assets/images/portrait/small/profile-placeholder.png');
Vue.prototype.$productImage = require('@/assets/images/products/product-kahve.png');

Vue.prototype.$toTurkishNow = function (d) {
  let dd = _.clone(d)
  return toTurkishNow(dd);
}
function toTurkishNow(d){
  if(!d) d = new Date(Date.now());
  d.setTime( d.getTime() - d.getTimezoneOffset()*60*1000 );
  return d;
}

Vue.prototype.$convertCurrency = function (value) {
  var formatter = new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
  });
  return formatter.format(value);
}
Vue.prototype.$othersPaymentId = process.env.VUE_APP_OTHERS_PAYMENT_ID;
Vue.prototype.$baseUrl = process.env.VUE_APP_ROOT_API;
Vue.prototype.$centerBranchId = process.env.VUE_APP_CENTER_BRANCH_ID;
Vue.prototype.$centerSupplierId = process.env.VUE_APP_CENTER_SUPPLIER_ID;
Vue.prototype.$tableMode = true;
Vue.prototype.$isCenterSupplier = function (supplier) {
  if(supplier === null || typeof(supplier) === "undefined") return false;
  return parseInt(process.env.VUE_APP_CENTER_SUPPLIER_ID) === supplier.id;
};
Vue.prototype.$isSuperAdminById = function(id){
  return process.env.VUE_APP_SUPER_ADMIN_ID == id;
};

Vue.prototype.$currentUser = store.getters["getActiveUser"];

Vue.prototype.$isNullOrEmpty = function (x) {
  return x === undefined || x == null || x === '';
};

Vue.prototype.$toCurrency = function(number, digit){
  let digits = digit ? digit : 2;
  return new Intl.NumberFormat('tr-TR', {minimumFractionDigits:digits,maximumFractionDigits:digits, currency:'TRY', style:'currency'}).format(number)
}

Vue.prototype.$isNullOrEmpty.props = function (obj) {
  if (Object.keys(obj).length === 0) return true;
  let nullCount = 0;
  for (var prop in obj) {
    if (obj[prop] === undefined || obj[prop] == null || obj[prop] === '') {
      nullCount++;
    }
  }
  if (Object.keys(obj).length <= nullCount) return true;
  else return false;
};

Vue.prototype.$isCenterBranch = function () {
  return store.getters["getActiveUser"].branch.id === parseInt(process.env.VUE_APP_CENTER_BRANCH_ID);
};
Vue.prototype.$isAdmin = function () {
  return store.getters["getActiveUser"].rols === "admin";
};
Vue.prototype.$isSuperAdmin = function () {
  return store.getters["getActiveUser"].id === 1;
};
Vue.prototype.$isRegionalCenterBranch = function () {
  console.log(store.getters["getActiveUser"].branch);
  return store.getters["getActiveUser"].branch.isCenter;
};

Vue.prototype.$needStockTransfer = function() {
  return store.getters["getNeedStockTransfer"];
}
Vue.prototype.$getBranchId = function() {
  return store.getters["getActiveUser"].branch.id;
}
Vue.config.productionTip = false;

// Mobil çift tıklama ve yakınlaştırma sorunlarını gidermek için
// Touch olaylarını kontrol eden kod
document.addEventListener('DOMContentLoaded', function() {
  // iOS'ta çift dokunma olaylarını yakalama
  let lastTouchEnd = 0;
  document.addEventListener('touchend', function(event) {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);

  // Parmakla döndürme ve yakınlaştırma olaylarını engelleme
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault();
  }, { passive: false });

  document.addEventListener('gesturechange', function(event) {
    event.preventDefault();
  }, { passive: false });

  document.addEventListener('gestureend', function(event) {
    event.preventDefault();
  }, { passive: false });
}, false);

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app');
